import React from 'react';

export const RemoveSpaces = value => value.replace(/\D/g, '');

const clearString = text => (
  text.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')
);

const renderHighLightText = (text, searchTerm) => {
  if (!searchTerm || searchTerm === '') return text;

  const cleanSearchTerm = clearString(searchTerm);
  const textParts = text.split(new RegExp(`(${cleanSearchTerm})`, 'gi'));

  return textParts.map((part, index) => {
    if (part.toLowerCase() === cleanSearchTerm.toLowerCase()) {
      return <strong key={index}>{part}</strong>;
    }

    return part;
  });
};

export const firstLetterCapitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export default renderHighLightText;
